export default __webpack_public_path__ + "static/media/User_HeroBanner.29a3d0cb.png";